import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import './css/style.css';
import './css/responsive.css';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { AboutUs } from './pages/AboutUs';
// import { BookAppointment } from './pages/BookAppointment';
import { ContactUs } from './pages/ContactUs';
import { Faq } from './pages/Faq';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsConditions } from './pages/TermsConditions';
import { Thankyou } from './pages/Thankyou';
import { Error } from './pages/Error';
import ScrollToTop from './components/ScrollToTop';


function App() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/services' element={<Services />} />
        <Route path='/about-us' element={<AboutUs />} />
        {/* <Route path='/book-appointment' element={<BookAppointment />} /> */}
        <Route path='/contact-us' element={<ContactUs />} />
        <Route path='/faq' element={<Faq />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/terms-conditions' element={<TermsConditions />} />
        <Route path='/thank-you' element={<Thankyou />} />
        <Route path='*' element={<Error />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
